export default __webpack_public_path__ + "media/shared/camera@3x-9395414a.png";